import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  CardContent, CardTitle, Button, Overlay, Image
} from '@thd-olt-component-react/core-ui';
import { clickEvent, impressionEvent } from '../publisher';
import { cardImageUrl } from '../plccUtils';
import './link-account.style.scss';

const LinkAccounts = ({ linkAccounts, consumerCard, commercialCard, isMobile }) => {
  const [showModal, setShowModal] = useState(false);

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const analyticsFeatureName = () => {
    if (commercialCard && consumerCard) {
      return 'plcc-link-accounts-multi-card';
    } if (commercialCard && !consumerCard) {
      return 'plcc-link-accounts-commercial';
    }
    return 'plcc-link-accounts';
  };

  const linkAccountClickHandler = () => {
    clickEvent(analyticsFeatureName());
    linkAccounts();
  };

  useEffect(() => {
    impressionEvent(analyticsFeatureName());
  }, []);

  const cardStack = () => {
    const cardStackClassName = consumerCard
      ? 'card-stack u--padding'
      : 'card-stack-no-consumer card-stack u--padding';
    if (commercialCard) {
      return (
        <div className={cardStackClassName}>
          <Image
            src={cardImageUrl.PLNP_HOMEDEPOT}
            alt="Home Depot Commercial Credit Card"
            width="80"
            height="50"
          />
          <Image
            src={cardImageUrl.PLCR_HOMEDEPOT}
            className="middle-card"
            alt="Home Depot Commercial Revolving Credit Card"
            width="80"
            height="50"
          />
          {consumerCard && (
            <Image
              src={cardImageUrl.PLCN_HOMEDEPOT}
              className="first-card"
              alt="Home Depot Consumer Credit Card"
              width="80"
              height="50"
            />
          )}
        </div>
      );
    }
    return (
      <Image
        src={cardImageUrl.PLCN_HOMEDEPOT}
        className="u--padding"
        alt="Home Depot Consumer Credit Card"
        width="80"
        height="50"
      />
    );
  };

  const creditCardDetails = (outlineButton) => {
    return (
      <div className="plcc-card">
        <div className="flex u__text-align--center">
          <Image
            src="https://assets.thdstatic.com/images/v1/hd-logo.svg"
            className="u--padding"
            alt="Home Depot Logo"
            width="55"
            height="55"
          />
          <Image
            src="https://assets.thdstatic.com/images/v1/link.svg"
            alt="Link Icon"
            width="20"
            height="20"
          />
          {cardStack()}
        </div>
        <h3 className="u__medium u__text-align--center u__bold u--paddingTop">
          Pay & Manage From One Account
        </h3>
        <p className="u--paddingTop u--paddingBottom">
          Make managing your card easier by linking your Citibank and Home Depot
          accounts. Once connected, you’ll be able to{' '}
          <span className="u__bold">pay your card and view your balance</span>{' '}
          from your HomeDepot.com account.
        </p>
        <Button
          outline={outlineButton}
          dark={outlineButton}
          className="margin-top"
          onClick={linkAccountClickHandler}
        >
          Link Accounts
        </Button>
      </div>
    );
  };

  return (
    <>
      <CardTitle title="My Home Depot Credit Card" />
      <CardContent title="My Home Depot Credit Card" maxHeight="none">
        <Overlay
          modalClass="link-accounts-overlay"
          closeButton
          isMobile={isMobile}
          open={showModal}
          onClose={closeModal}
          fit
        >
          <div className="u--paddingXlarge-horizontal">
            {creditCardDetails(false)}
          </div>
          <div className="u__text-align--center">
            <button
              className="u__default-link u--padding"
              onClick={closeModal}
              type="button"
            >
              Not Now
            </button>
          </div>
          <div className="u--padding terms-and-conditions u__border--top">
            <p className="u__text-align--center u__bold u--paddingTop">
              Terms & Conditions
            </p>
            <p className="u--paddingTop">
              By clicking “Link Accounts”, I acknowledge that I am linking my “My
              Account” login and password to my Home Depot Consumer Credit Card
              account. I understand this will allow anyone that has access to my
              “My Account” account information on homedepot.com complete access to
              my Home Depot Consumer Credit Card account. I understand that at any
              time, I can unlink these accounts by changing my settings in my “My
              Account” Account Profile on homedepot.com.
            </p>
          </div>
        </Overlay>
        <div className="u--padding">
          {creditCardDetails(true)}
          <p className="u__legal u__text-align--center u--paddingTop legal-text plcc-card">
            By clicking “Link Accounts” you agree to our{' '}
            <button
              className="u__default-link legal-click"
              onClick={openModal}
              type="button"
            >
              Terms and Conditions
            </button>{' '}
            and our
            <a
              className="u__default-link legal-click"
              href="https://www.homedepot.com/c/Privacy_Security"
              target="_blank"
              rel="noopener noreferrer"
            >
              {' '}
              Privacy And Security Statement.
            </a>
          </p>
        </div>
      </CardContent>
    </>
  );
};

LinkAccounts.propTypes = {
  linkAccounts: PropTypes.func.isRequired,
  consumerCard: PropTypes.bool,
  commercialCard: PropTypes.bool,
  isMobile: PropTypes.bool,
};
LinkAccounts.defaultProps = {
  consumerCard: true,
  commercialCard: false,
  isMobile: false,
};

export default LinkAccounts;
